import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ListaEspecialidades = ({ parentCallback, todas, disabled }) => {
  const [especialidades, setEspecialidades] = useState([]);
  const [especialidad, setEspecialidad] = useState("");
  const [nombreEspecialidad, setNombreEspecialidad] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/especialidades`)
      .then((response) => response.json())
      .then((data) => {
        if (todas) {
          setEspecialidad(0);
          setNombreEspecialidad("Todas");
        } else {
          setEspecialidad(data[0].esp_id);
          setNombreEspecialidad(data[0].esp_nombre);
        }
        setEspecialidades(data);
      });
    parentCallback(especialidad, nombreEspecialidad);
  }, []);

  useEffect(() => {
    parentCallback(especialidad, nombreEspecialidad);
  }, [especialidad, nombreEspecialidad]);

  return (
    <div className="form-group col-md-12">
      <label htmlFor="nombre">Especialidad:</label>
      <select
        className="form-select"
        aria-label="Default select example"
        onChange={(e) => {
          setNombreEspecialidad(e.target.options[e.target.selectedIndex].text);
          setEspecialidad(e.target.value);
        }}
        disabled={disabled}
      >
        {especialidades.length > 0 && todas === true && (
          <option key="0" value="0">
            Todas
          </option>
        )}
        {especialidades.length > 0 &&
          especialidades.map((especialidad) => {
            if (especialidad.esp_status === "1") {
              return (
                <option
                  disabled={especialidad.esp_status === "0"}
                  key={especialidad.esp_id}
                  value={especialidad.esp_id}
                >
                  {especialidad.esp_nombre}
                </option>
              );
            } else {
              return '<optiondefaultValue="">No existen especialidades</option>';
            }
          })}
      </select>
    </div>
  );
};

export default ListaEspecialidades;
